// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 5H0V19H21V5ZM6 15H4V9H6V15Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M24 15V9H22V15H24Z"}}]};

const BatteryLowFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'battery-low-filled',
    ref,
    icon: element,
  },
));

BatteryLowFilledIcon.displayName = 'BatteryLowFilledIcon';

export default BatteryLowFilledIcon;
